import React from 'react'

const BdAddress = () => {
    return (
        <div className='border p-8 bg-blue-100 w-full'>
            <div className='flex justify-between items-center'>
                <div>
                    <h1>Street: 17/4 Mymensingh.</h1>
                    <h1>City: Dhaka</h1>
                    <h1>Phone: +88016*******</h1>
                    <h1>Email: contact.bd@cc.com</h1>
                </div>
                <div>
                    <h1 className='text-2xl'>BANGLADESH OFFICE</h1>
                </div>
            </div>
        </div>
    )
}

export default BdAddress